// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".task-activity__post-button{display:inline-block;padding:10px;text-align:center;color:#fff;background-color:#dd5454;border:1px solid #c6c6c6}", ""]);
// Exports
module.exports = exports;
